/**
 * Common Scripts
 */
import 'common/common-scripts.js';

/**
 * Discount Specific Scripts
 */
import 'discount/discount-controller.js';
import 'voucher/voucher-controller.js';
import 'voucher/voucher-service.js';
